import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-sign-out',
  templateUrl: './icon-sign-out.component.html',
  styleUrls: ['./icon-sign-out.component.scss'],
  standalone: true,
})
export class IconSignOutComponent {
  @Input() color = '#E8EEF2';
  @Input() width = '20';
  @Input() height = '20';
}
